import { Common } from '@stockbit/ui';
import { Skeleton } from 'antd';
import { ProfileBoxContainer } from '../styled';

const { Flex } = Common;

function Loading() {
  return (
    <ProfileBoxContainer>
      <Flex m="20px">
        <Skeleton.Avatar size={100} active />
        <Flex direction="column" pl="20px">
          <Skeleton.Input active style={{ width: 150, marginBottom: '32px' }} />

          <Flex mb="16px">
            {[...new Array(3)].map((_, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <Flex direction="column" mr="12px" key={idx}>
                <Skeleton.Input
                  active
                  style={{ width: 50, height: 22, marginBottom: '4px' }}
                />
                <Skeleton.Input active style={{ width: 75, height: 16 }} />
              </Flex>
            ))}
          </Flex>
          <Flex>
            {[...new Array(3)].map((_, idx) => (
              <Skeleton.Input
                // eslint-disable-next-line react/no-array-index-key
                key={idx}
                active
                style={{ width: 100, height: 13, marginRight: '12px' }}
              />
            ))}
          </Flex>
        </Flex>
      </Flex>
    </ProfileBoxContainer>
  );
}

export default Loading;
